import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { COUNTRIES } from '../data/foodData';

const CountrySelector = ({ activeCountry, onSelect }) => {
    const [radius, setRadius] = useState(300);

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            if (width < 480) setRadius(140);
            else if (width < 768) setRadius(180);
            else if (width < 1024) setRadius(240);
            else setRadius(300);
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className="country-selector-section" id="countries">
            <div className="section-title" style={{ textAlign: 'center', marginBottom: '6rem' }}>
                <h2 style={{ fontSize: 'var(--h2-size)', fontWeight: '800' }}>
                    Explore By <span style={{ color: 'var(--primary)' }}>Cuisine</span>
                </h2>
                <p style={{ color: 'var(--text-muted)', fontSize: '1.1rem', marginTop: '1rem' }}>
                    Our world-class selection - keeping the globe spinning
                </p>
            </div>

            <div className="selector-container" style={{ width: radius * 2.2, height: radius * 2.2 }}>
                {/* 
                   Perfectly Aligned Dashed Circle 
                   Now perfectly tracking the center of the pods.
                */}
                <div
                    className="rotating-circle"
                    style={{
                        width: radius * 2,
                        height: radius * 2,
                        zIndex: 1,
                        border: '2px dashed rgba(245, 158, 11, 0.25)',
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%) rotate(0deg)'
                    }}
                ></div>

                <motion.div
                    className="wheel-pods-container"
                    style={{ position: 'absolute', inset: 0, zIndex: 10 }}
                    animate={{ rotate: 360 }}
                    transition={{ duration: 100, repeat: Infinity, ease: "linear" }}
                >
                    {COUNTRIES.map((country, index) => {
                        const total = COUNTRIES.length;
                        const angle = (index / total) * 2 * Math.PI;
                        const x = Math.cos(angle) * radius;
                        const y = Math.sin(angle) * radius;

                        return (
                            <div
                                key={country.name}
                                className={`country-node ${activeCountry === country.name ? 'active' : ''}`}
                                style={{
                                    left: `calc(50% + ${x}px)`,
                                    top: `calc(50% + ${y}px)`,
                                    position: 'absolute',
                                    transform: 'translate(-50%, -50%)'
                                }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onSelect(country.name);
                                }}
                            >
                                <motion.div
                                    animate={{ rotate: -360 }}
                                    transition={{ duration: 100, repeat: Infinity, ease: "linear" }}
                                    style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
                                >
                                    {/* Pod with centered content */}
                                    <div
                                        className="country-pod"
                                        style={{
                                            backgroundImage: `url(${country.dishImage})`,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            textAlign: 'center',
                                            flexDirection: 'column'
                                        }}
                                    >
                                        <div className="pod-glow"></div>

                                        {/* Country Name perfectly centered inside */}
                                        <div style={{
                                            zIndex: 5,
                                            fontSize: '0.8rem',
                                            fontWeight: '900',
                                            textTransform: 'uppercase',
                                            letterSpacing: '1px',
                                            color: 'white',
                                            textShadow: '0 2px 8px rgba(0,0,0,1)',
                                            padding: '0 5px'
                                        }}>
                                            {country.name}
                                        </div>
                                    </div>
                                </motion.div>
                            </div>
                        );
                    })}
                </motion.div>
            </div>
        </div>
    );
};

export default CountrySelector;
